
























































































































































import Vue from 'vue';
import { Component, Prop, Inject, Ref } from 'vue-property-decorator';
import Navbar from "@/components/Navbar.vue";
import SoftwareList from "@/components/SoftwareList.vue";
import * as types from "@/types";

@Component({
	components: {
		Navbar,
		SoftwareList
	}
})
export default class App extends Vue {

	@Ref("navbar")
	public navbar: Navbar;

	public async mounted(): Promise<void> {
		await this.$auth.handleRedirect();
	}
}
